import React from 'react';
import {Link} from '../comun/Index';
const menu = require('./menu.json');

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  render(){
    //const {} = this.state;
    return(
      <div className="Menu">
        {menu.opciones.map((item, index) => {
          return(
            <Link
              key={index}
              titulo={item.titulo}
              color="rgba(255,102,0,1)"
              url={item.url}
              ir={(url) => this.props.history.push(url)}
            />
          )
        })}
      </div>
    );
  }
}

export default Main;
